import { RawTrader, TraderDerivation, HistoryTradeRow } from './types';

export const POS = '#157A4C';
export const NEG = '#C0413C';
export const INK = '#16202E';
export const TEAL = '#0E9C9C';
export const GOLD = '#A06C10';
export const MUTE = '#5C6779';

export const TONE = {
  good: { fg: '#157A4C', bg: '#EFF8F3', bd: '#CFE9DC' },
  warn: { fg: '#A06C10', bg: '#FDF6EA', bd: '#EFDFBE' },
  bad: { fg: '#C0413C', bg: '#FCEEEC', bd: '#F2D5D2' },
};

export const SCORE_META = [
  ['Hiệu suất', '25%', 'Lợi nhuận tuyệt đối và tăng trưởng theo tháng'],
  ['Quản trị rủi ro', '30%', 'Drawdown, rủi ro mỗi lệnh, vi phạm giới hạn'],
  ['Tính ổn định', '20%', 'Tỷ lệ tháng dương và độ lệch lợi nhuận'],
  ['Kỷ luật', '15%', 'Tuân thủ hệ thống, khối lượng, kế hoạch vào lệnh'],
  ['Ổn định giao dịch', '10%', 'Đều đặn về số lệnh và khối lượng theo thời gian'],
];

export const SIZE_TABS = [
  ['all', 'Tất cả'],
  ['50', '50K'],
  ['100', '100K'],
  ['200', '200K'],
  ['300', '300K'],
  ['400', '400K'],
];

export const PERIODS = ['1M', '3M', '6M', 'YTD', 'Tất cả'];
export const MONTH_LABELS = ['T10', 'T11', 'T12', 'T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'T8', 'T9'];
export const RADAR_LABELS = ['Hiệu suất', 'Quản trị rủi ro', 'Tính ổn định', 'Kỷ luật', 'Lệnh thắng', 'Mật độ GD'];

export const rng = (seed: number) => {
  let s = seed;
  return () => {
    s = (s * 1664525 + 1013904223) % 4294967296;
    return s / 4294967296;
  };
};

export const hash = (str: string) => {
  let h = 7;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) % 100000;
  return h + 11;
};

export const money = (v: number) => (v < 0 ? '-' : '') + '$' + Math.abs(Math.round(v)).toLocaleString('en-US');
export const sMoney = (v: number) => (v > 0 ? '+' : v < 0 ? '-' : '') + '$' + Math.abs(Math.round(v)).toLocaleString('en-US');
export const sPct = (v: number, d?: number) => (v > 0 ? '+' : '') + v.toFixed(d === undefined ? 1 : d) + '%';
export const initials = (n: string) =>
  n
    .trim()
    .split(/\s+/)
    .slice(-2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();

export const chipStyle = (active: boolean) =>
  active
    ? { background: '#06223B', color: '#ffffff', borderColor: '#06223B' }
    : { background: '#ffffff', color: MUTE, borderColor: '#E7EBF0' };

export const starColors = (n: number) =>
  Array.from({ length: 5 }, (_, i) => (i < n ? '#E39A2B' : '#DDE3EA'));

export const REVIEW_WARN = [
  {
    name: 'Lâm Quốc Huy',
    s: 4,
    date: '02/09/2026',
    months: 7,
    cap: '$50,000',
    helpful: 12,
    text: 'Lợi nhuận tốt hơn phần lớn trader tôi từng theo, nhưng có giai đoạn drawdown khá sâu nên phải chuẩn bị tinh thần. Ai vốn nhỏ và không chịu được biến động thì nên cân nhắc.',
    reply: 'Đúng như anh nói. Tôi đang giảm dần rủi ro mỗi lệnh và số liệu gần nhất đã ổn định hơn.',
    replyDate: '03/09/2026',
  },
  {
    name: 'Trịnh Bảo Ngọc',
    s: 4,
    date: '21/08/2026',
    months: 5,
    cap: '$100,000',
    helpful: 8,
    text: 'Kết quả bám sát số liệu công khai, lệnh khớp nhanh. Điểm trừ là khối lượng giữa các lệnh chênh nhau khá nhiều, có lệnh lớn hơn hẳn lệnh khác.',
  },
  {
    name: 'Đặng Hữu Phước',
    s: 3,
    date: '14/08/2026',
    months: 4,
    cap: '$25,000',
    helpful: 7,
    text: 'Đã có lúc tài khoản chạm gần giới hạn lỗ ngày trong thời gian tôi theo. Trader vẫn kéo lại được nhưng tôi phải giảm tỷ lệ copy xuống một nửa cho yên tâm.',
    reply: 'Những lúc đó đều rơi vào phiên tin. Từ đó tôi đã dừng giao dịch trong khung 30 phút quanh tin lớn.',
    replyDate: '15/08/2026',
  },
  {
    name: 'Ngô Thuỳ Linh',
    s: 4,
    date: '30/07/2026',
    months: 4,
    cap: '$50,000',
    helpful: 5,
    text: 'Đọc thị trường tốt, vào lệnh có lý do rõ ràng. Tôi chỉ mong phần quản trị khối lượng nhất quán hơn thì đây sẽ là hồ sơ rất mạnh.',
  },
  {
    name: 'Vương Tuấn Kiệt',
    s: 2,
    date: '18/07/2026',
    months: 3,
    cap: '$10,000',
    helpful: 4,
    text: 'Tôi vào đúng giai đoạn drawdown và mất khá lâu mới về bờ. Hiệu suất dài hạn vẫn dương nhưng biên độ dao động quá lớn so với khẩu vị của tôi.',
  },
  {
    name: 'Hồ Anh Duy',
    s: 3,
    date: '05/07/2026',
    months: 3,
    cap: '$200,000',
    helpful: 4,
    text: 'Giai đoạn đầu có lãi nhưng phần lớn đến từ một vài tuần tốt nhất. Cần thêm thời gian mới đánh giá được tính ổn định.',
  },
];

export const REVIEW_BAD = [
  {
    name: 'Lâm Quốc Huy',
    s: 2,
    date: '02/09/2026',
    months: 6,
    cap: '$50,000',
    helpful: 18,
    text: 'Tài khoản đang âm và drawdown gần chạm mức sâu nhất từ trước tới nay. Tôi đã tạm dừng copy để chờ trader ổn định lại khối lượng.',
    reply: 'Tôi đã giảm khối lượng theo yêu cầu của mentor và tạm dừng giao dịch tin. Xin lỗi vì giai đoạn này.',
    replyDate: '03/09/2026',
  },
  {
    name: 'Trịnh Bảo Ngọc',
    s: 2,
    date: '21/08/2026',
    months: 5,
    cap: '$100,000',
    helpful: 11,
    text: 'Số lần chạm giới hạn lỗ ngày là quá nhiều. Lệnh khớp không có vấn đề gì, vấn đề nằm ở quản trị rủi ro.',
  },
  {
    name: 'Đặng Hữu Phước',
    s: 1,
    date: '14/08/2026',
    months: 4,
    cap: '$25,000',
    helpful: 9,
    text: 'Khối lượng tăng mạnh ngay sau chuỗi lệnh thua, đây là dấu hiệu gỡ gạc. Tôi đã dừng theo vốn từ giữa giai đoạn đó.',
    reply: 'Nhận xét của anh chính xác. Tôi đã cố định lại khối lượng và đang trong giai đoạn theo dõi của mentor.',
    replyDate: '16/08/2026',
  },
  {
    name: 'Ngô Thuỳ Linh',
    s: 3,
    date: '30/07/2026',
    months: 4,
    cap: '$50,000',
    helpful: 5,
    text: 'Trader minh bạch, có báo cáo sau mỗi tuần lỗ và không né tránh. Điểm thấp là vì kết quả, không phải vì thái độ.',
  },
  {
    name: 'Vương Tuấn Kiệt',
    s: 2,
    date: '18/07/2026',
    months: 3,
    cap: '$10,000',
    helpful: 6,
    text: 'Profit factor dưới 1 nghĩa là lỗ gộp đang lớn hơn lãi gộp. Số liệu trên trang đã nói rõ, tôi chỉ xác nhận là tài khoản của tôi cũng vậy.',
  },
];

export const REVIEW_POOL = [
  {
    name: 'Lâm Quốc Huy',
    s: 5,
    date: '02/09/2026',
    months: 8,
    cap: '$50,000',
    helpful: 14,
    text: 'Tháng nào cũng có báo cáo rõ ràng và không tháng nào drawdown vượt ngưỡng tôi đặt ra. Điểm mạnh nhất là giữ nguyên khối lượng khi thị trường biến động mạnh, không gồng lệnh.',
    reply: 'Cảm ơn anh. Tôi giữ nguyên quy tắc rủi ro cố định cho mỗi lệnh ở mọi giai đoạn, kể cả khi có chuỗi thắng.',
    replyDate: '03/09/2026',
  },
  {
    name: 'Trịnh Bảo Ngọc',
    s: 5,
    date: '21/08/2026',
    months: 6,
    cap: '$100,000',
    helpful: 9,
    text: 'Kết quả đúng như số liệu công khai, không có chênh lệch đáng kể giữa tài khoản của tôi và tài khoản gốc. Slippage thấp, lệnh vào khớp trong vài giây.',
  },
  {
    name: 'Đặng Hữu Phước',
    s: 4,
    date: '14/08/2026',
    months: 5,
    cap: '$25,000',
    helpful: 6,
    text: 'Lợi nhuận ổn định nhưng số lệnh khá ít trong tháng vừa rồi, có tuần rất ít lệnh. Hiểu là do trader chờ setup nhưng nhà đầu tư nhỏ sẽ hơi sốt ruột. Vẫn tiếp tục theo.',
    reply: 'Tháng vừa rồi biến động thấp nên tôi chủ động giảm tần suất. Ưu tiên chất lượng setup hơn số lệnh.',
    replyDate: '15/08/2026',
  },
  {
    name: 'Ngô Thuỳ Linh',
    s: 5,
    date: '30/07/2026',
    months: 4,
    cap: '$50,000',
    helpful: 5,
    text: 'Điều tôi đánh giá cao là phần giải thích sau mỗi tuần lỗ. Không né tránh, nói rõ lệnh nào sai và điều chỉnh gì.',
  },
  {
    name: 'Vương Tuấn Kiệt',
    s: 3,
    date: '18/07/2026',
    months: 3,
    cap: '$10,000',
    helpful: 3,
    text: 'Hiệu suất tốt nhưng tài khoản nhỏ như của tôi bị lệch tỷ lệ lot khá nhiều nên lợi nhuận thực tế thấp hơn con số công bố một chút. Mong hệ thống hỗ trợ chia lot chính xác hơn.',
  },
  {
    name: 'Hồ Anh Duy',
    s: 4,
    date: '05/07/2026',
    months: 3,
    cap: '$200,000',
    helpful: 4,
    text: 'Giai đoạn đầu kết quả bám sát bảng số liệu. Chưa đủ dài để kết luận nhưng cách quản trị rủi ro rất kỷ luật, chưa lần nào chạm giới hạn lỗ ngày.',
  },
  {
    name: 'Phan Mỹ Duyên',
    s: 2,
    date: '22/06/2026',
    months: 2,
    cap: '$10,000',
    helpful: 2,
    text: 'Tôi vào đúng giai đoạn drawdown nên đang âm. Không phải lỗi của trader nhưng tôi thấy phần cảnh báo rủi ro trước khi theo vốn nên rõ hơn.',
    reply: 'Chia sẻ của chị hợp lý. Giai đoạn đó là chuỗi lỗ dài nhất trong năm, số liệu này có trong tab Rủi ro.',
    replyDate: '23/06/2026',
  },
  {
    name: 'Bùi Trọng Nghĩa',
    s: 5,
    date: '09/06/2026',
    months: 7,
    cap: '$100,000',
    helpful: 8,
    text: 'Đã theo qua hai giai đoạn thị trường khác nhau, kết quả không phụ thuộc vào một loại điều kiện duy nhất. Đây là điểm khác biệt so với các trader tôi từng theo.',
  },
];

export const getTraderReviewPool = (t: RawTrader) => {
  const pool = t.tone === 'good' ? REVIEW_POOL : t.tone === 'warn' ? REVIEW_WARN : REVIEW_BAD;
  const maxMonths = Math.max(1, Math.floor(t.days / 30));
  const h = hash(t.name);
  const drop = (maxMonths < 3 ? 2 : 0) + (h % 3);
  const bump = h % 2 ? 1 : -1;
  const bumpAt = h % Math.max(pool.length - drop, 1);
  const out = pool
    .slice(0, Math.max(pool.length - drop, 3))
    .map((r, i) =>
      i === bumpAt
        ? Object.assign({}, r, { s: Math.max(1, Math.min(5, r.s + bump)) })
        : r
    );
  return { pool: out, maxMonths };
};


export const derive = (t: RawTrader): TraderDerivation => {
  const trades = Math.round(t.days * 1.9);
  const wins = Math.round((trades * t.wr) / 100);
  const losses = trades - wins;
  const profit = (t.cap * t.ret) / 100;
  const grossLoss = Math.abs(profit / (t.pf - 1));
  const grossWin = grossLoss * t.pf;
  const avgWin = grossWin / Math.max(wins, 1);
  const avgLoss = grossLoss / Math.max(losses, 1);
  return {
    trades,
    wins,
    losses,
    profit,
    grossWin,
    grossLoss,
    avgWin,
    avgLoss,
    best: avgWin * 4.2,
    worst: -avgLoss * 3.4,
    exp: profit / trades,
    recovery: profit / ((t.cap * t.dd) / 100),
    balance: t.cap + profit,
    equity: t.cap + profit * 0.97,
    avgRisk: (t.dd / 10) * (t.tone === 'bad' ? 1.6 : 1),
    rr: (t.pf * (100 - t.wr)) / t.wr,
    cWins: Math.round(3 + t.wr / 12),
    cLosses: Math.round(2 + t.dd / 3),
    sharpe: (t.pf - 0.9) * 0.9,
    perWeek: Math.round(trades / (t.days / 5)),
  };
};

export const series = (t: RawTrader) => {
  const r = rng(hash(t.name));
  const n = 130;
  const vol = 0.35 + t.dd / 14;
  let v = 0;
  const raw = [];
  for (let i = 0; i < n; i++) {
    v += t.ret / n + (r() - 0.5) * vol;
    raw.push(v);
  }
  const k = t.ret / (raw[n - 1] || 1);
  return raw.map((x) => x * k);
};

export const monthsCalc = (t: RawTrader) => {
  const r = rng(hash(t.name) + 7);
  const base = t.ret / 12;
  const vol = 0.7 + t.dd / 8;
  const out = [];
  for (let i = 0; i < 12; i++) out.push(base + (r() - 0.5) * vol * 2);
  const k = t.ret / out.reduce((a, b) => a + b, 0);
  return out.map((x) => +(x * k).toFixed(1));
};

export const historyRows = (t: RawTrader, d: TraderDerivation): HistoryTradeRow[] => {
  const r = rng(hash(t.name) + 21);
  const pool = t.tags.includes('Indices')
    ? ['XAUUSD', 'EURUSD', 'US30', 'GBPUSD']
    : ['XAUUSD', 'EURUSD', 'GBPUSD', 'USDJPY'];
  const rows: HistoryTradeRow[] = [];
  for (let i = 0; i < 16; i++) {
    const sym = pool[Math.floor(r() * 4)];
    const win = r() < t.wr / 100;
    const sizeVal = win ? d.avgWin * (0.4 + r() * 1.6) : -d.avgLoss * (0.4 + r() * 1.6);
    const px =
      sym === 'XAUUSD'
        ? 2380 + r() * 90
        : sym === 'US30'
        ? 41200 + r() * 600
        : sym === 'USDJPY'
        ? 148 + r() * 3
        : 1.07 + r() * 0.06;
    const dec = px > 100 ? 2 : 4;
    const move = (win ? 1 : -1) * px * (0.002 + r() * 0.006);
    const dir = r() < t.long / 100 ? 'BUY' : 'SELL';
    rows.push({
      date:
        String(8 - Math.floor(i / 2)).padStart(2, '0') +
        '/09 ' +
        String(8 + Math.floor(r() * 10)).padStart(2, '0') +
        ':' +
        String(Math.floor(r() * 60)).padStart(2, '0'),
      sym,
      dir,
      win,
      entry: px.toFixed(dec),
      exit: (px + (dir === 'BUY' ? move : -move)).toFixed(dec),
      lot: (0.4 + r() * 2.4).toFixed(2),
      pnl: sMoney(sizeVal),
      pct: sPct((sizeVal / t.cap) * 100, 2),
      dur:
        r() < 0.4
          ? Math.floor(1 + r() * 9) + 'h ' + Math.floor(r() * 59) + 'm'
          : Math.floor(1 + r() * 4) + 'd ' + Math.floor(r() * 20) + 'h',
      c: sizeVal >= 0 ? POS : NEG,
      dirBg: dir === 'BUY' ? '#EAF6F6' : '#FDF3E3',
      dirFg: dir === 'BUY' ? '#0B7A7A' : GOLD,
    });
  }
  return rows;
};
